import { DataTable, Loader } from "@/components";
import useAuditLog from "./useAuditLog";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui";

const AuditLog = () => {
  const { logs, columns, isLoadingLogs } = useAuditLog();

  return (
    <Accordion type="single" collapsible className="w-full">
      <AccordionItem value="audit-log" className="bg-white px-5 rounded-lg mb-[20px] shadow-md">
        <AccordionTrigger className="cursor-pointer">
          Audit Log
        </AccordionTrigger>
        <AccordionContent>
          Tracks Close/Reopen with user, date & time, system references and reasons
          <div className="py-4">
            {isLoadingLogs ? <Loader /> :
              <DataTable
                data={logs?.data || []}
                columns={columns}
                className="shadow-none"
              />
            }
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default AuditLog;